<ng-container *ngIf="viewModel$ | async as vm">
  <div class="modal-header">
    <h4 class="modal-title">Stats</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.close('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="table mt-1 table-hover">
      <thead>
        <tr>
          <th scope="col">Campaign ID</th>
          <th scope="col">Campaign Name</th>
          <th scope="col">Outcome</th>
          <th scope="col">Quantity</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="vm.results === undefined">
          <td colspan="6">Loading...</td>
        </tr>
        <tr *ngIf="vm.results && vm.results.length === 0">
          <td colspan="6">No Records Found...</td>
        </tr>
        <tr *ngFor="let r of vm.results; let i = index">
          <td *ngIf="vm.results !== undefined">
            {{
              i === 0 || vm.results[i - 1].campaignName !== r.campaignName
                ? r.campaignId !== 0
                  ? r.campaignId
                  : ""
                : ""
            }}
          </td>
          <td *ngIf="vm.results !== undefined">
            {{
              i === 0 || vm.results[i - 1].campaignName !== r.campaignName
                ? r.campaignName
                : ""
            }}
          </td>
          <td>{{ r.outcome }}</td>
          <td>{{ r.qty }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>
